module.exports = __webpack_public_path__ + "img/icon2.7c865970.png";